import type { LedgerAccountsQueryParams } from './useQueryLedgerAccounts';
import type { ValidateLedgerAccountUniquenessQueryParams } from './useQueryValidateLedgerAccountUniqueness';

import type { UUID } from '~/types/common';

/**
 * Query key factory for ledger-account queries.
 */
export const queryKeysLedgerAccount = {
  base: () => 'ledgerAccount' as const,
  get: (ledgerAccountId: UUID) =>
    [queryKeysLedgerAccount.base(), 'detail', { ledgerAccountId }] as const,
  getAll: (queryParams?: Partial<LedgerAccountsQueryParams>) =>
    [queryKeysLedgerAccount.base(), 'list', queryParams].filter(Boolean),
  validateUniqueness: (
    queryParams: ValidateLedgerAccountUniquenessQueryParams,
  ) =>
    [queryKeysLedgerAccount.base(), 'validateUniqueness', queryParams] as const,
} as const;
